import {createAction} from 'web-app/util/redux/famly-app-helpers';
import {type PaymentsSourceType} from 'web-app/util/graphql/api-types';

const domain = 'MODALS/PAYMENTS_VERIFICATION';

export const {action: show} = createAction(
    `${domain}/SHOW`,
    (institutionId: string, paymentsAccountId: string, selectedSourceTypes: PaymentsSourceType[]) => ({
        institutionId,
        paymentsAccountId,
        selectedSourceTypes,
    }),
);

export const {action: hide} = createAction(`${domain}/HIDE`, () => ({}));

export const {action: loading} = createAction(`${domain}/LOADING`, () => ({}));

export const {action: done} = createAction(`${domain}/DONE`, () => ({}));
